import React from 'react';
import { Copy } from '@grubhubprod/gh-cookbook-react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';
import { CustomLabelWithTooltip } from 'src/components/common/CustomLabelWithTooltip/CustomLabelWithTooltip';

export interface ProviderConnectionIdControlProps {
  name: string;
  id: string;
}

export function ProviderConnectionIdControl({
  name,
  id,
}: ProviderConnectionIdControlProps): JSX.Element {
  const { errors, control } = useFormContext();
  const requiredMessage = 'Provider Connection ID is required';
  const isEmptyValue = (value: string): boolean | string =>
    value.trim() !== '' || requiredMessage;

  return (
    <CookbookInputWrapper
      name={name}
      id={id}
      control={control}
      error={errors[name]}
      aria-label={name}
      inputSize="medium"
      blockWidth
      maxLength={50}
      label={
        <CustomLabelWithTooltip
          color="primaryText"
          labelText="Provider Connection ID *"
          tooltipInfo={
            <Copy variant="body" color="invertedPrimaryText">
              The provider connection ID will be provided by Grubhub's IT team.
              You must obtain the SSO certificate from the corporate client
              first.
            </Copy>
          }
        />
      }
      rules={{
        required: requiredMessage,
        validate: {
          isEmpty: isEmptyValue,
        },
      }}
    />
  );
}
